// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"table-1"},"children":[{"tag":"path","attrs":{"id":"fill1","fill":"props.fillColor1","d":"M21 21L21 9L3 9L3 21L21 21Z"}},{"tag":"path","attrs":{"id":"fill2","fill":"props.fillColor2","d":"M21 3L3 3L3 9H9L15 9L21 9V3Z"}},{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M21 9V21H3V9M21 9H3M21 9V3H3V9M21 9L15 9M3 9L9 9M9 9H15M9 9V21M15 9V21","strokeWidth":"props.strokeWidth"}}]}]};

const Table1Icon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'table-1',
    ref,
    icon: element,
  },
));

Table1Icon.displayName = 'Table1Icon';

export default Table1Icon;
